import { exportPrivateCryptoKeyToPem, exportPublicCryptoKeyToPem } from '@lucidlink/ts-crypto/crypto';
import { isNil } from '@lucidlink/tscore';
import { createBase64RsaCrypto, createRsaCrypto, RSA_DEFAULT_SCHEME } from './node-forge';
export const createAdminCryptoProvider = (idService) => {
    return new AdminCryptoProvider(idService);
};
class AdminCryptoProvider {
    idService;
    adminCrypto;
    constructor(idService) {
        this.idService = idService;
    }
    async getCrypto() {
        if (isNil(this.adminCrypto)) {
            this.adminCrypto = createBase64RsaCrypto(await this.createAdminRsaCrypto());
        }
        return this.adminCrypto;
    }
    async createAdminRsaCrypto() {
        const adminGroupId = this.idService.getAdminGroupId();
        const adminCryptoKeys = (await this.idService.getPrincipalsCrypto([adminGroupId]))[adminGroupId];
        const adminPublicKeyPem = await exportPublicCryptoKeyToPem(adminCryptoKeys.publicKey);
        const adminPrivateKeyPem = await exportPrivateCryptoKeyToPem(adminCryptoKeys.privateKey);
        return createRsaCrypto({
            scheme: RSA_DEFAULT_SCHEME,
            serializedPublicKey: adminPublicKeyPem,
            serializedPrivateKey: adminPrivateKeyPem,
        });
    }
}
